import { createRoot } from 'react-dom/client';
import InstanceApp from './InstanceApp.js';
import { StrictMode } from 'react';

const rootElement = document.getElementById('explorer-root');

if (rootElement) {
    createRoot(rootElement).render(
        <StrictMode>
            <InstanceApp />
        </StrictMode>
);
}